"use client";

import { useQuery } from "@tanstack/react-query";

export type ProductVariation = {
  product_id: string;
  variation_id: string;
  value: number;
  price: string;
};

export type ProductsInfo = {
  "Monthly Personal": ProductVariation[];
  "Annual Personal": ProductVariation[];
  "Monthly Business": ProductVariation[];
  "Annual Business": ProductVariation[];
  "Monthly Per Proxy Mobile"?: ProductVariation[];
  "Monthly Per GB Mobile": ProductVariation[];
  "Monthly Per GB Residential": ProductVariation[];
  checkoutBaseUrl?: string;
};

async function fetchProductsInfo(): Promise<ProductsInfo> {
  const res = await fetch("/api/products-info");
  if (!res.ok) throw new Error("Failed to fetch products info");
  return res.json();
}

export function useProductsInfo(): ProductsInfo | null {
  const { data } = useQuery<ProductsInfo>({
    queryKey: ["products-info"],
    queryFn: fetchProductsInfo,
    staleTime: 60 * 60 * 1000, // 1 hour — matches server cache
    gcTime: 2 * 60 * 60 * 1000, // keep in memory for 2 hours
  });
  return data ?? null;
}

// Helpers for pricing lookups
export function lookupMonthlyPrice(tiers: ProductVariation[], value: number): number | null {
  const tier = tiers.find((t) => t.value === value);
  return tier ? parseFloat(tier.price) : null;
}

export function lookupAnnualMonthlyPrice(tiers: ProductVariation[], value: number): number | null {
  const tier = tiers.find((t) => t.value === value);
  if (!tier) return null;
  return Math.round((parseFloat(tier.price) / 12) * 100) / 100;
}

export function lookupAnnualTotal(tiers: ProductVariation[], value: number): number | null {
  const tier = tiers.find((t) => t.value === value);
  return tier ? parseFloat(tier.price) : null;
}
